import { styled, Container } from '@mui/material';

export const DialogFooterContainer = styled(Container)({
  display: 'flex',
  justifyContent: 'flex-end',
  height: '42px',
  gap: '16px',
});
